import React, { useEffect, useState } from 'react';
import { daMinutiAOre } from './turniHelper';
import {Button} from "react-bootstrap";
import { downloadCsv } from '../utilities/NetUtilities';

function TabellaServizio(props) {
    const [tabellaServizio, setTabellaServizio] = useState(null)
    const [totMinutiServizio, setTotMinutiServizio] = useState(0)
    useEffect(() => {
        setTabellaServizio(props.tabellaServizio)
        setTotMinutiServizio(props.minutiTotServizio);
    }, [props.minutiTotServizio, props.tabellaServizio])

    const printRiga = (servizio, minuti, indexServizio) => {
        return (<tr key={`row-${indexServizio}`}>
                    <td className='cellaSpaziosa bordiSpessi' id={'servizio-' + indexServizio}>{servizio}</td>
                    <td className="center cellaSpaziosa bordiSpessi" id={'oreservizio-' + indexServizio}>{daMinutiAOre(minuti)}</td>
                </tr>
        )
    }

    const printTabella = () => {
        return (Object.keys(tabellaServizio).map((servizio, indexServizio) => {
            var minuti = tabellaServizio[servizio];
            return (printRiga(servizio, minuti, indexServizio))
        }))
    }

    const printTotale = () => {
       
        return (<tr>
            <td id={'totservizio'} className="inEvidenza cellaSpaziosa right bordiSpessi">totale ore</td>
            <td id={'oretotservizio'} className="inEvidenza cellaSpaziosa center bordiSpessi">{daMinutiAOre(totMinutiServizio)}</td>
        </tr>
)
    }

    return (
        <div id="tabella-servizio" className='table-responsive'>
        <h2 className='inEvidenza'>Totale servizio  
            <Button
                data-toggle="tooltip"
                title="Download CSV"
                className='btnGenerale'
                variant="flat"
                size="sm"
                id="csv-servizio"
                onClick={() => { downloadCsv(props.urlCsv, "totale-servizio.csv") }}
            >scarica</Button></h2>
            {tabellaServizio && <table id="tabella-servizio" className='table-bordered bottom-space' >
                <thead  className="App">
                    <tr key="intestazione">
                        <th className="inEvidenza cellaSpaziosa bordiSpessi">servizio</th>
                        <th className="inEvidenza cellaSpaziosa bordiSpessi">totale (hh:mm)</th>
                    </tr>
                </thead>
                <tbody>
                    {printTabella()}
                    {printTotale()}
                </tbody>
            </table>}
        </div>
    )
}

export default TabellaServizio;